import React, { useEffect, useRef, useState } from "react";
import { useNavigate } from "react-router-dom";
import Select from "react-select";
import CloseSharpIcon from "@mui/icons-material/CloseSharp";
import {
  delete_icon,
  dummyimage,
  edit_icon,
  Search_icon,
  view_icon,
} from "../../assets/img";
import { Table } from "../../components/Table/Table";
import DateRange from "../../components/DateRange/DateRange";
import Topbar from "../../components/Topbar/Topbar";
import PropertyReqFileds from "../../components/Property/PropertyReqFileds";
import { checkPermission } from "../../screen/redux/api/PermissionManager";
import moment from "moment";

const SingleUser = ({
  data,
  handleCoupon,
  deleteCoupon,
  pagination,
  setPagination,
  setPage,
  page,
  typeview,
}) => {
  const inputRef = useRef(null);
  const navigate = useNavigate();
  // const [page, setPage] = useState(1);
  // const [pagination, setPagination] = useState("");
  const [selectedImage, setSelectedImage] = useState(dummyimage);
  const [popup, setPopup] = useState(false);
  const [bannerPopup, setBannerPopup] = useState(false);
  const [state, setState] = useState();
  const [city, setCity] = useState();
  const [fromDate, setFormDate] = useState();
  const [toDate, setToDate] = useState();
  const [activeStatus, setActiveStatus] = useState(1);
  const [isValue, setIsValue] = useState(null);

  const [owners, setOwners] = useState(
    data
    // [
    // {
    //   Banner: dummyimage,
    //   coupontype: "Percentage",
    //   Couponname: "SUMMER50",
    //   Codegeneratedtype: "Auto",
    //   Couponamount: "50%",
    //   Servicetype: "Cleaning",
    //   State: "Tamil Nadu",
    //   City: "Chennai",
    //   Minpurchase: "₹500",
    //   StartDate: "2025-02-01",
    //   EndDate: "2025-02-28",
    //   Createdby: "Admin John",
    //   status: "on",
    // },
    // {
    //   Banner: dummyimage,
    //   coupontype: "Flat",
    //   Couponname: "WELCOME100",
    //   Codegeneratedtype: "Manual",
    //   Couponamount: "₹100",
    //   Servicetype: "Plumbing",
    //   State: "Karnataka",
    //   City: "Bengaluru",
    //   Minpurchase: "₹1000",
    //   StartDate: "2025-03-01",
    //   EndDate: "2025-03-15",
    //   Createdby: "Admin Lisa",
    //   status: "off",
    // },
    // {
    //   Banner: dummyimage,
    //   coupontype: "Percentage",
    //   Couponname: "FEST20",
    //   Codegeneratedtype: "Auto",
    //   Couponamount: "20%",
    //   Servicetype: "Electrical",
    //   State: "Telangana",
    //   City: "Hyderabad",
    //   Minpurchase: "₹300",
    //   StartDate: "2025-04-01",
    //   EndDate: "2025-04-30",
    //   Createdby: "Admin Steve",
    //   status: "on",
    // },
    // {
    //   Banner: dummyimage,
    //   coupontype: "Flat",
    //   Couponname: "SAVE500",
    //   Codegeneratedtype: "Manual",
    //   Couponamount: "₹500",
    //   Servicetype: "Painting",
    //   State: "Kerala",
    //   City: "Kochi",
    //   Minpurchase: "₹2000",
    //   StartDate: "2025-05-01",
    //   EndDate: "2025-05-31",
    //   Createdby: "Admin Kate",
    //   status: "on",
    // },
    // {
    //   Banner: dummyimage,
    //   coupontype: "Percentage",
    //   Couponname: "DIWALI25",
    //   Codegeneratedtype: "Auto",
    //   Couponamount: "25%",
    //   Servicetype: "Gardening",
    //   State: "Maharashtra",
    //   City: "Mumbai",
    //   Minpurchase: "₹1500",
    //   StartDate: "2025-06-01",
    //   EndDate: "2025-06-15",
    //   Createdby: "Admin Raj",
    //   status: "off",
    // },
    // ]
  );
  useEffect(() => setOwners(data), [data]);

  const handleImageClick = () => {
    inputRef.current.click();
  };
  const handleStatus = (id) => {
    handleCoupon(id?.id);
    // const updatedData = [...owners]; // Create a copy of the data
    // const currentStatus = updatedData[id].status || "on"; // Default to "on" if undefined

    // updatedData[id].status = currentStatus === "on" ? "off" : "on";
    // setOwners(updatedData);
    // console.log("KK", id);
    // let value = data.filter((ele, i) => i == id ? ele.status == "off" ? "on" : "off")
  };

  const users = [
    { id: 1, name: "Chennai", age: 28, city: "New York" },
    { id: 2, name: "Banglore", age: 34, city: "Los Angeles" },
    { id: 3, name: "Hyderabad", age: 22, city: "Chicago" },
    { id: 4, name: "Nellore", age: 25, city: "Miami" },
    { id: 5, name: "Guntur", age: 40, city: "San Francisco" },
  ];
  const ownerList = [
    { id: 1, name: "John Doe", age: 28, city: "New York" },
    { id: 2, name: "Jane Smith", age: 34, city: "Los Angeles" },
    { id: 3, name: "Sam Brown", age: 22, city: "Chicago" },
    { id: 4, name: "Emily Johnson", age: 25, city: "Miami" },
    { id: 5, name: "Michael Davis", age: 40, city: "San Francisco" },
  ];
  const options = users.map((item) => {
    let obj = {};
    obj.value = item.name;
    obj.label = item.name;
    return obj;
  });
  const ownerOptions = ownerList.map((item) => {
    let obj = {};
    obj.value = item.name;
    obj.label = item.name;
    return obj;
  });

  // const columns = React.useMemo(
  //   () => [
  //     {
  //       Header: "S.No",
  //       accessor: "S.No",
  //       Cell: ({ row }) => {
  //         const pageSize = 10;
  //         return <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>;
  //       },
  //     },
  //     {
  //       Header: "Banner",
  //       accessor: "Banner",
  //       Cell: ({ value, row }) => {
  //         return <img src={dummyimage} className="list-img" />;
  //       },
  //     },
  //     {
  //       Header: " coupon type",
  //       accessor: "coupontype",
  //       Cell: ({ value, row }) => {
  //         return <p>{value}</p>;
  //       },
  //     },
  //     {
  //       Header: "Coupon name",
  //       accessor: "Couponname",
  //       Cell: ({ value, row }) => {
  //         return <p>{value}</p>;
  //       },
  //     },
  //     {
  //       Header: " Code generated type",
  //       accessor: "Codegeneratedtype",
  //       Cell: ({ value, row }) => {
  //         return <p>{value}</p>;
  //       },
  //     },

  //     {
  //       Header: "Coupon amount",
  //       accessor: "Couponamount",
  //       Cell: ({ value, row }) => {
  //         return <p className="text-nowrap">{value}</p>;
  //       },
  //     },
  //     {
  //       Header: " Service type ",
  //       accessor: "Servicetype",
  //       Cell: ({ value, row }) => {
  //         return <p className="text-nowrap">{value}</p>;
  //       },
  //     },
  //     {
  //       Header: "State",
  //       accessor: "State",
  //       Cell: ({ value, row }) => {
  //         return <p className="text-nowrap">{value}</p>;
  //       },
  //     },
  //     {
  //       Header: "City",
  //       accessor: "City",
  //       Cell: ({ value, row }) => {
  //         return <p className="text-nowrap">{value}</p>;
  //       },
  //     },
  //     {
  //       Header: "Min purchase",
  //       accessor: "Minpurchase",
  //       Cell: ({ value, row }) => {
  //         return <p className="text-nowrap">{value}</p>;
  //       },
  //     },
  //     {
  //       Header: "Start Date",
  //       accessor: "StartDate",
  //       Cell: ({ value, row }) => {
  //         return <p className="text-nowrap">{value}</p>;
  //       },
  //     },
  //     {
  //       Header: "End Date",
  //       accessor: "EndDate",
  //       Cell: ({ value, row }) => {
  //         return <p className="text-nowrap">{value}</p>;
  //       },
  //     },
  //     {
  //       Header: "Created by",
  //       accessor: "Createdby",
  //       Cell: ({ value, row }) => {
  //         return <p className="text-nowrap">{value}</p>;
  //       },
  //     },
  //     {
  //       Header: "Status",
  //       accessor: "status",
  //       Cell: ({ value, row }) => {
  //         return (
  //           <div>
  //             {row.original.role != "Super Admin" && (
  //               <button
  //                 onClick={() => {
  //                   // if (givenpermissions?.includes("CAN-Status-ADMINS")) {
  //                   handleStatus(row);
  //                   // handleStatus(row.original.id);
  //                   // }
  //                 }}
  //                 className={`${value == "off" ? "deactive-btn" : "active-btn"
  //                   } border-0 ms-2`}
  //                 style={{ fontSize: "12px" }}
  //               >
  //                 {value == "off" ? "De-active" : " Active"}
  //               </button>
  //             )}
  //           </div>
  //         );
  //       },
  //     },

  //     {
  //       Header: "Action",
  //       accessor: "",
  //       Cell: ({ row }) => (
  //         <div className="d-flex ac-js">

  //           <button
  //             onClick={() => {
  //               navigate("/coupon-single-add", {
  //                 state: { type: "edit", datas: row.original },
  //               });
  //             }}
  //             className="cust-btn"
  //           >
  //             <img src={edit_icon} alt="" className="mx-2 edit-btn" />
  //           </button>
  //           <button onClick={() => setPopup(true)} className="cust-btn">
  //             <img src={delete_icon} alt="" className="mx-2 edit-btn" />
  //           </button>
  //         </div>
  //       ),
  //     },
  //   ],
  //   [page]
  // );
  const columns = React.useMemo(
    () => [
      {
        Header: "S.No",
        accessor: "S.No",
        Cell: ({ row }) => {
          const pageSize = 10;
          return <p className="red">{row.index + 1 + (page - 1) * pageSize}</p>;
        },
      },
      {
        Header: "Banner",
        accessor: "external_image",
        Cell: ({ value, row }) => {
          return <img src={value || dummyimage} className="list-img" />;
        },
      },
      {
        Header: " coupon type",
        accessor: "type",
        Cell: ({ value, row }) => {
          // const couponType = ["Influencer", "Multiple Users", "Single User"];
          console.log("COUPONTYPEEEE", row.original, value);
          return (
            <p>
              {value == 1
                ? "Influencer"
                : value == 2
                ? "Multiple Users"
                : value == 3
                ? "Single User"
                : ""}
            </p>
          );
        },
      },
      {
        Header: "Coupon name",
        accessor: "name",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },
      {
        Header: " Code generated type",
        accessor: "code",
        Cell: ({ value, row }) => {
          return <p>{value}</p>;
        },
      },

      {
        Header: "Coupon amount",
        accessor: "amount",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: " Service type ",
        accessor: "service_name",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "State",
        accessor: "state_count",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "City",
        accessor: "city_count",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Min purchase",
        accessor: "min_purchase_amount",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Start Date",
        accessor: "from_date",
        Cell: ({ value, row }) => {
          return (
            <p className="text-nowrap">
              {value && moment(value).format("DD/MM/YYYY")}
            </p>
          );
        },
      },
      {
        Header: "End Date",
        accessor: "to_date",
        Cell: ({ value, row }) => {
          return (
            <p className="text-nowrap">
              {(value && moment(value).format("DD/MM/YYYY")) || "-"}
            </p>
          );
        },
      },
      {
        Header: "Created by",
        accessor: "created_by",
        Cell: ({ value, row }) => {
          return <p className="text-nowrap">{value}</p>;
        },
      },
      {
        Header: "Status",
        accessor: "status",
        Cell: ({ value, row }) => {
          return (
            <div>
              {row.original.role != "Super Admin" && (
                <button
                  onClick={() => {
                    if (checkPermission("CAN-STATUS-COUPON"))
                      handleStatus(row?.original);
                  }}
                  className={`${
                    value == 2 ? "deactive-btn" : "active-btn"
                  } border-0 ms-2`}
                  style={{ fontSize: "12px" }}
                >
                  {value == 2 ? "De-active" : " Active"}
                </button>
              )}
            </div>
          );
        },
      },

      {
        Header: "Action",
        accessor: "",
        Cell: ({ row }) => (
          <div className="d-flex ac-js">
            {checkPermission("CAN-EDIT-COUPON") && (
              <button
                onClick={() => {
                  navigate("/coupon-single-add", {
                    state: { type: "edit", datas: row.original },
                  });
                }}
                className="cust-btn"
              >
                <img src={edit_icon} alt="" className="mx-2 edit-btn" />
              </button>
            )}
            {checkPermission("CAN-DELETE-COUPON") && (
              <button
                onClick={() => {
                  setPopup(true);
                  setIsValue(row?.original);
                }}
                className="cust-btn"
              >
                <img src={delete_icon} alt="" className="mx-2 edit-btn" />
              </button>
            )}
          </div>
        ),
      },
    ],
    [page, owners]
  );
  const handlerDeleteCoupon = () => {
    deleteCoupon(isValue?.id);
    setPopup(false);

    console.log("isValue", isValue);
  };
  return (
    <div>
      <Table
        columns={columns}
        setPageno={setPage}
        pagecount={pagination}
        data={owners}
        show={true}
      />
      {popup && (
        <div className="img-popup-design">
          <div className="img-popup">
            <p className="f3 ms-2  ms-md-2 ms-lg-2 ms-xl-2 fs-xs-10 fs-sm-11 fs-md-12 fs-lg-13 fs-xl-14 fs-xxl-15 mt-4">
              Are you sure, want to Delete?
            </p>
            <div className="d-flex ac-jb px-2 mt-5">
              <button
                onClick={() => handlerDeleteCoupon()}
                className="add-btn w-40"
              >
                Yes
              </button>
              <button
                onClick={() => {
                  setPopup(false);
                  // logout();
                }}
                className="back-btn f2 w-40"
              >
                {/* {loading ? "Loading..." : "Confirm"} */}No
              </button>
            </div>
          </div>
        </div>
      )}
    </div>
  );
};

export default SingleUser;
